import { defaultInitialState } from '../utils';
import { SEND_TICKET, SEND_TICKET_DONE, SEND_TICKET_ERROR, RESET_SEND_TICKET } from './actionTypes';
const initialState = Object.assign({}, defaultInitialState);
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_TICKET:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case SEND_TICKET_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case SEND_TICKET_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case RESET_SEND_TICKET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map